import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { MfaResetConfirmDocument } from '@graphql/generated/graphql';

import { useFindCompanyByCode } from '@utils/hooks/useFindCompanyByCode';

import { getPath } from '@services/RouteService/paths';

import { useMutation } from '@apollo/client';

export const useResetMfaToken = (
    companyCode: string | null,
    mfaResetToken: string | null,
) => {
    const navigate = useNavigate();

    const [findCompanyByCode, companyOptions] = useFindCompanyByCode();
    const [resetConfirm, { error, loading: resetLoading }] = useMutation(
        MfaResetConfirmDocument,
        {
            context: {
                notifyOnError: true,
            },
            onError: () => {},
        },
    );

    const loading =
        companyOptions.loading || !companyOptions.called || resetLoading;

    useEffect(() => {
        const resetMfa = async () => {
            try {
                if (!companyCode) throw new Error('Could not get company code');
                if (!mfaResetToken)
                    throw new Error('Could not get reset token');

                await findCompanyByCode({
                    variables: {
                        companyCode,
                    },
                });
                await resetConfirm({
                    variables: {
                        mfaResetToken,
                    },
                });
            } catch (error) {
                navigate(getPath({ path: '/auth/welcome' }));
                console.error('useResetMfaToken :: ', { error });
            }
        };

        void resetMfa();
    }, [companyCode, mfaResetToken]);

    return {
        error: error || companyOptions.error,
        loading,
        resetConfirm,
    };
};
